<template>
  <router-link to="/">
    <v-img max-width="300px" class="logo" src="/assets/custom/img/case/logo-banner.gif" alt="CASE" />
  </router-link>
</template>
